import { Configuration, PopupRequest } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || 'your-client-id',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID || 'your-tenant-id'}`,
    redirectUri: window.location.origin,
  },
  cache: {
    // localStorage, not sessionStorage: a phone camera opens every scanned
    // label QR (/j/:n) in a new tab, and a sessionStorage cache is empty in a
    // new tab, so every scan landed on the login page. Accepted trade-off: a
    // staff device stays signed in after the browser closes
    // (docs/qr-scan-workflow-requirements.md §9, D12).
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest: PopupRequest = {
  scopes: ['User.Read'],
};

/**
 * Token request for sm4rt-api. Its Easy Auth accepts only tokens issued for this
 * scope (audience `api://sm4rt-api`); the SPA is pre-authorised on that app
 * registration, so staff see no consent prompt. `services/apiAuthFetch.ts`
 * attaches the token to every `/api/*` call.
 */
export const apiRequest = {
  scopes: ['api://sm4rt-api/access_as_user'],
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};